<template>
  <div>
    <h5>{{ title }}</h5>

    <pie-chart
      :height="155"
      :colorCycle="generateColorPool(totalDisplay(chartData), hueRange)"
      :data="totalDisplay(chartData)"
      :options="pieChartOptions"
      @onClick="handleProfileClicked($event, chartData)"
    />
    <chart-legend
      :colorCycle="generateColorPool(totalDisplay(chartData), hueRange)"
      :data="totalDisplay(chartData)"
      :isPercentage="totalDisplayOption === 'percentage'"
    />
  </div>
</template>

<script>
import colorMixin from '@/mixins/colors';
import BarChart from '@/components/charts/BarChart';
import PieChart from '@/components/charts/PieChart';
import ChartLegend from '@/components/charts/ChartLegend';

export default {
  name: 'SpotProfileChart',
  mixins: [colorMixin],
  components: {
    BarChart,
    PieChart,
    ChartLegend,
  },
  props: {
    field: {
      type: String,
      required: true,
    },
    hueRange: {
      type: Array,
      required: true,
    },
    chartData: {
      type: Array,
      required: true,
    },
    totalDisplayOption: {
      type: String,
      default: 'percentage',
    },
  },
  computed: {
    genderItem() {
      return gender => this.chartData.filter(g => g.title === gender)[0];
    },
    genderPercentages() {
      return gender => {
        const genderData = this.chartData.filter(d => d[0] === gender);
        return genderData[0][1];
      };
    },
    genderPercentage() {
      const total = this.chartData.reduce(
        (a, b) => a[this.totalDisplayOption] + b[this.totalDisplayOption],
      );

      const formatMap = {
        percentage: (c, t) => `${Math.round(c / t * 100)}%`,
        total: c => c.toLocaleString(),
        cume: c => c.toLocaleString(),
      };

      return gender => {
        const count = this.chartData.filter(g => g.title === gender)[0][this.totalDisplayOption];
        const format = formatMap[this.totalDisplayOption](count, total);
        return format;
      };
    },
    title() {
      return this.field.replace('_', ' ').replace(/(^|\s)\S/g, t => t.toUpperCase());
    },
    totalDisplay() {
      return answers => answers.map(a => [a.title, a[this.totalDisplayOption]]);
    },

    chartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generateTooltipLabel,
          },
        },
      };
    },
    pieChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generatePieTooltipLabel,
          },
        },
      };
    },
  },
  methods: {
    generateTooltipLabel(tooltipItem, data) {
      const label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

      const formatMap = {
        percentage: l => `${l}%`,
        total: l => l.toLocaleString(),
        cume: l => l.toLocaleString(),
      };

      return formatMap[this.totalDisplayOption](label);
    },

    generatePieTooltipLabel(tooltipItem, data) {
      const total = this.generateTooltipLabel(tooltipItem, data);
      const label = data.labels[tooltipItem.index];

      return `${label}: ${total}`;
    },

    handleProfileClicked(event, profileItem) {
      /* eslint-disable no-underscore-dangle */
      const answer = profileItem[event[1][0]._index];
      this.$emit('onRequestRespondents', {
        filtering: { choice_id: answer.choice_id },
        title: this.title,
        subtitle: answer.title,
      });
    },

    handleGenderClicked(event, answer) {
      this.$emit('onRequestRespondents', {
        filtering: { choice_id: answer.choice_id },
        title: this.title,
        subtitle: answer.title,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gender-respondents {
  min-width: 210px;
  height: 155px;

  .gender-block {
    display: inline-block;
    text-align: center;
  }
  .fa {
    margin-top: 14px;
    font-size: 80px;
  }
  .fa-male {
    color: #2da1d8;
  }
  .fa-female {
    color: #e132c7;
  }
  .gender-percentage {
    margin-top: 12px;
    font-size: 1.2em;
  }
}
</style>



// WEBPACK FOOTER //
// SpotProfileChart.vue?50d25e9e